import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat"
export default class extends Controller {
  static values = { currentUser: Number }

  connect() {
    this.updateLayouts()
    this.observer = new MutationObserver(() => this.updateLayouts())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer.disconnect()
  }

  updateLayouts() {
    document.querySelectorAll(".message").forEach((el) => {
      const senderId = parseInt(el.dataset.userId)

      if (senderId === this.currentUserValue) {
        el.classList.add("message-current-user")
      } else {
        el.classList.add("message-other-user")
      }
    })
  }
}
